import { axiosApi } from '~/axios'
import { ApiController } from '~/utils/classes/ApiController'
import { fromObjectToFormData } from '~/utils/functions'
import { Params } from '~/utils/interfaces'
import {
  CarAgency,
  CarBooking,
  CarCategory,
  CarClient,
  CarContract,
  CarOffice,
  CarPriceConfig,
  CarSearch,
  CarSeason,
  ContractPrice,
  ContractSharedPrice,
  CreateCarAgency,
  CreateCarBooking,
  CreateCarCategory,
  CreateCarClient,
  CreateCarContract,
  CreateCarOffice,
  CreateCarPriceConfig,
  CreateCarSeason,
  CreateContractPrice,
  CreateContractSharedPrice,
} from '~/utils/interfaces/rentalCar'

export const carAgencyController = new ApiController<
  CarAgency,
  CreateCarAgency
>('/rental-cars/car-agencies/', 'image')

export const carCategoryController = new ApiController<
  CarCategory,
  CreateCarCategory
>('/rental-cars/categories/')

export const carOfficeController = new ApiController<
  CarOffice,
  CreateCarOffice
>('/rental-cars/offices/')

export const carSeasonsController = new ApiController<
  CarSeason,
  CreateCarSeason
>('/rental-cars/seasons/')

export const carBookingsController = new ApiController<
  CarBooking,
  CreateCarBooking
>('/rental-cars/bookings/list/')

export const carPriceConfigController = new ApiController<
  CarPriceConfig,
  CreateCarPriceConfig
>('/rental-cars/price-config/')

export const carClientsController = new ApiController<
  CarClient,
  CreateCarClient
>('/rental-cars/clients/')

export const getBookingPdf = (uuid: string) =>
  axiosApi.get(`/rental-cars/bookings/pdf-details/${uuid}/`, {
    responseType: 'arraybuffer',
  })

export const sendBookingPdf = (uuid: string) =>
  axiosApi.patch(`/rental-cars/bookings/sendpdf-details/${uuid}/`)

export const sendBookingVoucher = (uuid: string) =>
  axiosApi.patch(`/rental-cars/bookings/send-pdf/${uuid}/`)

export const confirmCarBooking = (uuid: string, body: { voucher: File }) => {
  const formdata = fromObjectToFormData(body)
  return axiosApi.patch(`/rental-cars/bookings/confirm/${uuid}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const carContractController = new ApiController<
  CarContract,
  CreateCarContract
>('/rental-cars/contract/list/')

export const carContractSharedController = new ApiController<
  CarContract,
  CreateCarContract
>('/rental-cars/contract/shared/')

export const carContractSharedPriceController = new ApiController<
  ContractSharedPrice,
  CreateContractSharedPrice
>('/rental-cars/contract/shared-prices/')

export const carContractPriceController = new ApiController<
  ContractPrice,
  CreateContractPrice
>('/rental-cars/contract/prices/')

export const shareCarContract = (
  uuid: string,
  body: {
    agency: string
    prices: CreateContractPrice[]
  },
) => axiosApi.patch(`/rental-cars/contract/share/${uuid}/`, body)

export const changeCarContractStatus = (body: {
  uuid: string
  is_active: boolean
}) =>
  axiosApi.patch(`/rental-cars/contract/change-status/${body.uuid}/`, {
    is_active: body.is_active,
  })

export const searchCarCategories = (body: {
  pick_up_office: string
  pick_up_datetime: string
  drop_off_office: string
  drop_off_datetime: string
  category: string
}) => axiosApi.post<CarSearch>('/rental-cars/search/', body)

export const cancelCarBooking = (uuid: string, description?: string) =>
  axiosApi.patch(`/rental-cars/bookings/cancel/${uuid}/`, { description })

export const getCarBookingInvoice = (uuid: string) =>
  axiosApi.get(`/rental-cars/bookings/invoice/${uuid}/`, {
    responseType: 'arraybuffer',
  })

export const getCarBookingXls = (params?: Params) =>
  axiosApi.get(`/rental-cars/bookings/xls/`, {
    params,
    responseType: 'arraybuffer',
  })
